export default __webpack_public_path__ + "static/media/7.26aaa461.jpg";